import React, { useState, useEffect } from "react";
import { Card, CardMedia, CardContent, Typography, Box, Avatar, TextField, Pagination } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ScaleIcon from "@mui/icons-material/Scale";
import { useFetchAdsQuery } from "../../store/services/adService";
import Loader from "../../components/Loader";
import { IMAGE_URL } from "../../store/services/constants";
import colors from "../../styles/colors";
import { useNavigate } from "react-router-dom";

const VehicleCard = () => {

    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    // Debounce search term to trigger API only after user stops typing
    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchTerm.length >= 3 || searchTerm === "") {
                setDebouncedSearchTerm(searchTerm);
            }
        }, 500); // Trigger search after 500ms

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data, error, isLoading } = useFetchAdsQuery({ page, search: debouncedSearchTerm });

    const ads = data?.data?.data || []; // Extract ads array
    const totalPages = data?.data?.last_page || 1; // Extract total pages for pagination

    const handlePageChange = (event, value) => {
        setPage(value); // Update the page number
    };

    return (
        <Box sx={{ padding: 2 }}>
            {/* Search Bar */}
            <Box sx={{ display: "flex", mb: 3 }}>
                <TextField
                    variant="outlined"
                    fullWidth
                    sx={{ maxWidth: 600 }}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search by name or price..."
                />
            </Box>

            {/* Cards */}
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                {isLoading && <Loader open={isLoading} />}
                {error && (
                    <Typography color="error" variant="body1">
                        Failed to load ads.
                    </Typography>
                )}
                {!isLoading &&
                    !error &&
                    ads.map((ad) => (
                        <Card
                            onClick={() => navigate(`/dashboard/ad-details/${ad.id}`)}
                            key={ad.id}
                            sx={{
                                width: 280,
                                borderRadius: 3,
                                boxShadow: 3,
                                overflow: "hidden",
                                position: "relative",
                                cursor: 'pointer'
                            }}
                        >
                            {/* Ad Image */}
                            <CardMedia
                                component="img"
                                height="140"
                                image={ad.images?.[0]?.image ? `${IMAGE_URL}${ad.images[0].image}` : "https://via.placeholder.com/200"}
                                alt={ad.name}
                            />

                            {/* User Info */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px",
                                    gap: 1,
                                    position: "absolute",
                                    top: 8,
                                    left: 8,
                                    background: "rgba(255, 255, 255, 0.8)",
                                    borderRadius: 16,
                                }}
                            >
                                <Avatar
                                    src={ad.user?.image ? `${IMAGE_URL}${ad.user.image}` : "https://via.placeholder.com/40"}
                                    alt={ad.user?.username}
                                    sx={{ width: 24, height: 24 }}
                                />
                                <Typography
                                    sx={{ fontFamily: "PMe", fontSize: 12 }}
                                    color="text.secondary"
                                >
                                    {ad.user?.username || "Unknown"}
                                </Typography>
                            </Box>

                            {/* Ad Details */}
                            <CardContent>
                                <Typography
                                    sx={{ fontFamily: "PBo", fontSize: 16, mb: 1 }}
                                    noWrap
                                >
                                    {ad.name}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        mb: 1,
                                    }}
                                >
                                    <StarIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography
                                        sx={{ fontFamily: "PMe", fontSize: 12 }}
                                        color="text.secondary"
                                    >
                                        {parseFloat(ad.average_rating).toFixed(1)}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontFamily: "PRe",
                                            fontSize: 12,
                                            color: ad.is_rented ? "error.main" : "success.main",
                                        }}
                                    >
                                        {ad.is_rented ? "Rented" : "Available"}
                                    </Typography>
                                </Box>

                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <ScaleIcon
                                            color="action"
                                            sx={{ fontSize: 16, mr: 0.5 }}
                                        />
                                        <Typography
                                            sx={{ fontFamily: "PMe", fontSize: 12 }}
                                        >
                                            {ad.weight}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <AttachMoneyIcon
                                            color="success"
                                            sx={{ fontSize: 16, mr: 0.5 }}
                                        />
                                        <Typography
                                            sx={{ fontFamily: "PMe", fontSize: 12 }}
                                        >
                                            {`${ad.price_hourly} OMR/hr`}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
            </Box>

            {/* Pagination */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                // color={"#000000"}
                />
            </Box>
        </Box>
    );
};

export default VehicleCard;


// import React from "react";
// import { Card, CardMedia, CardContent, Typography, Box, Avatar } from "@mui/material";
// import StarIcon from "@mui/icons-material/Star";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import ScaleIcon from "@mui/icons-material/Scale";
// import { useFetchAdsQuery } from "../../store/services/adService";
// import Loader from "../../components/Loader";
// import { IMAGE_URL } from "../../store/services/constants";

// const VehicleCard = () => {
//     const { data, error, isLoading } = useFetchAdsQuery(1); // Fetch data for page 1

//     const ads = data?.data?.data || []; // Extract the ads array

//     return (
//         <Box
//             sx={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: 2,
//                 padding: 2,
//             }}
//         >
//             {ads.map((ad) => (
//                 <Card
//                     key={ad.id}
//                     sx={{
//                         width: 280,
//                         borderRadius: 3,
//                         boxShadow: 3,
//                         overflow: "hidden",
//                         position: "relative",
//                     }}
//                 >
//                     {/* Ad Image */}
//                     <CardMedia
//                         component="img"
//                         height="140"
//                         image={ad.images?.[0]?.image ? `${IMAGE_URL}${ad.images[0].image}` : "https://via.placeholder.com/200"}
//                         alt={ad.name}
//                     />

//                     {/* User Info */}
//                     <Box
//                         sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             padding: "8px",
//                             gap: 1,
//                             position: "absolute",
//                             top: 8,
//                             left: 8,
//                             background: "rgba(255, 255, 255, 0.8)",
//                             borderRadius: 16,
//                         }}
//                     >
//                         <Avatar
//                             src={ad.user?.image ? `${IMAGE_URL}${ad.user.image}` : "https://via.placeholder.com/40"}
//                             alt={ad.user?.username}
//                             sx={{ width: 24, height: 24 }}
//                         />
//                         <Typography
//                             sx={{ fontFamily: "PMe", fontSize: 12 }}
//                             color="text.secondary"
//                         >
//                             {ad.user?.username || "Unknown"}
//                         </Typography>
//                     </Box>

//                     {/* Ad Details */}
//                     <CardContent>
//                         <Typography
//                             sx={{ fontFamily: "PBo", fontSize: 16, mb: 1 }}
//                             noWrap
//                         >
//                             {ad.name}
//                         </Typography>
//                         <Box
//                             sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1,
//                                 mb: 1,
//                             }}
//                         >
//                             <StarIcon color="success" sx={{ fontSize: 14 }} />
//                             <Typography
//                                 sx={{ fontFamily: "PMe", fontSize: 12 }}
//                                 color="text.secondary"
//                             >
//                                 {parseFloat(ad.average_rating).toFixed(1)}
//                             </Typography>
//                             <Typography
//                                 sx={{
//                                     fontFamily: "PRe",
//                                     fontSize: 12,
//                                     color: ad.is_rented ? "error.main" : "success.main",
//                                 }}
//                             >
//                                 {ad.is_rented ? "Rented" : "Available"}
//                             </Typography>
//                         </Box>

//                         <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 <ScaleIcon
//                                     color="action"
//                                     sx={{ fontSize: 16, mr: 0.5 }}
//                                 />
//                                 <Typography
//                                     sx={{ fontFamily: "PMe", fontSize: 12 }}
//                                 >
//                                     {ad.weight}
//                                 </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 {/* <AttachMoneyIcon
//                                     color="success"
//                                     sx={{ fontSize: 16, mr: 0.5 }}
//                                 /> */}
//                                 <Typography
//                                     sx={{ fontFamily: "PMe", fontSize: 12 }}
//                                 >
//                                     {`${ad.price_hourly} OMR/hr`}
//                                 </Typography>
//                             </Box>
//                         </Box>
//                     </CardContent>
//                 </Card>
//             ))}

//             <Loader open={isLoading} />
//         </Box>
//     );
// };

// export default VehicleCard;
